import { environment } from '../../../environments/environment';
import { RegistrarContactoRequest, RegistrarContactoResponse } from '../models/RegistrarContacto';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthUserRequest, AuthUserResponse } from '../models/AuthUser';
import { CreateProcessRequest, ResponseCreateProcess, SignioProccesResponse, SignioProcess } from '../models/CreateProcess';
import { CreateSignioTransactionModel, SignioCrearResponse } from '../models/CreateSignioTransaction';
import { CargarDocumentoRequest, CargarDocumentoResponse } from '../models/CargarDocumento';
import { FirmaElctronicaResponse, VincularRequest } from '../models/Vincular';
import { DocumentBitesResponse, ObtenerDocumentoRequest } from '../models/ObtenerDocumento';
import { TransaccionBaseByDocumentoResponse } from '../models/TransaccionBaseByDocumento';
import { DtoUpdateQuoteDocument } from '../models/DtoUpdateQuoteDocument';

@Injectable({
  providedIn: 'root',
})
export class FirmaElectronicaService {
  urlFirma: string = environment.UrlServices.API_Firma;
  urlArrendamiento: string = environment.UrlServices.API_Leasing;

  constructor(private http: HttpClient) {}

  GetTokenFirmaElectronica(): Observable<AuthUserResponse> {
    const request: AuthUserRequest = new AuthUserRequest();
    return this.http.post<AuthUserResponse>(
      `${this.urlFirma}/api/Auth/GetToken`,
      request
    );
  }

  CrearProceso(
    token: string,
    request: CreateProcessRequest
  ): Observable<ResponseCreateProcess> {
    const headers = new HttpHeaders({
      Authorization: 'Bearer ' + token,
    });
    return this.http.post<ResponseCreateProcess>(
      `${this.urlFirma}/api/Process/CrearProceso`,
      request,
      { headers }
    );
  }

  Crear(
    token: string,
    request: CreateSignioTransactionModel
  ): Observable<SignioCrearResponse> {
    const headers = new HttpHeaders({
      Authorization: 'Bearer ' + token,
    });
    return this.http.post<SignioCrearResponse>(
      `${this.urlFirma}/api/Signio/Crear`,
      request,
      { headers }
    );
  }
  CargarDocumento(
    token: string,
    request: CargarDocumentoRequest
  ): Observable<CargarDocumentoResponse> {
    const headers = new HttpHeaders({
      Authorization: 'Bearer ' + token,
    });
    return this.http.post<CargarDocumentoResponse>(
      `${this.urlFirma}/api/Signio/Cargar_documento`,
      request,
      { headers }
    );
  }
  RegistrarContacto(
    token: string,
    request: RegistrarContactoRequest
  ): Observable<RegistrarContactoResponse> {
    const headers = new HttpHeaders({
      Authorization: 'Bearer ' + token,
    });
    return this.http.post<RegistrarContactoResponse>(
      `${this.urlFirma}/api/Signio/Registrar_contacto`,
      request,
      { headers }
    );
  }
  Vincular(
    token: string,
    request: VincularRequest
  ): Observable<FirmaElctronicaResponse> {
    const headers = new HttpHeaders({
      Authorization: 'Bearer ' + token,
    });
    return this.http.post<FirmaElctronicaResponse>(
      `${this.urlFirma}/api/Signio/Vincular`,
      request,
      { headers }
    );
  }
  Distribuir(
    token: string,
    id_transaccion: string
  ): Observable<FirmaElctronicaResponse> {
    const headers = new HttpHeaders({
      Authorization: 'Bearer ' + token,
    });
    return this.http.get<FirmaElctronicaResponse>(
      `${this.urlFirma}/api/Signio/Distribuir?id_transaccion=${id_transaccion}`,
      { headers }
    );
  }

  GetProcess(token: string, id_process: number): Observable<SignioProcess> {
    const headers = new HttpHeaders({
      Authorization: 'Bearer ' + token,
    });
    return this.http.get<SignioProcess>(
      `${this.urlFirma}/api/Process/GetProcess?id_proceso=${id_process}`,
      { headers }
    );
  }

  GetDocumentByProcess(
    token: string,
    documentoRequest: ObtenerDocumentoRequest
  ): Observable<DocumentBitesResponse> {
    const headers = new HttpHeaders({
      Authorization: 'Bearer ' + token,
    });
    return this.http.post<DocumentBitesResponse>(
      `${this.urlFirma}/api/Process/GetDocumentByProcess`,
      documentoRequest,
      { headers }
    );
  }

  GetTransaccionBaseByDocumento(
    token: string,
    Id_Docimento: number
  ): Observable<TransaccionBaseByDocumentoResponse> {
    const headers = new HttpHeaders({
      Authorization: 'Bearer ' + token,
    });
    return this.http.get<TransaccionBaseByDocumentoResponse>(
      `${this.urlFirma}/api/SignioParametrizacion/GetTransaccionBaseByDocumento?Id_Docimento=${Id_Docimento}`,
      { headers }
    );
  }

  UpdateProcessQuoteDocument(quoteDocumen: DtoUpdateQuoteDocument): Observable<any> {
    return this.http.post<any>(`${this.urlArrendamiento}/APILeasing/api/QuoteDocuments/UpdateProcessQuoteDocument`,quoteDocumen);
  }
}

